// extracted by mini-css-extract-plugin
module.exports = {"oldValue":"PolicyDiffComponent_oldValue__nkmxw","newValue":"PolicyDiffComponent_newValue__1lYNn"};